module.exports = __webpack_public_path__ + "b9f12adc53160a1f70769fc8d7f809e1.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/404_generic.png
// module id = 429
// module chunks = 0